import { queryOptions } from '@tanstack/react-query';
import type { BusinessProfileInput, BusinessProfileResponse } from '@mybusinessmate/schema';
import { mapResponseError } from '@mybusinessmate/api-client';
import { api } from './api';

/** `null` = the signed-in user has not saved a business profile yet (a normal state, not an error). */
export async function fetchProfile(): Promise<BusinessProfileResponse | null> {
  const res = await api.api.business.profile.$get();
  if (res.status === 404) return null;
  if (!res.ok) throw await mapResponseError(res);
  return res.json();
}

export const profileQueryOptions = queryOptions({
  queryKey: ['business', 'profile'] as const,
  queryFn: fetchProfile,
  staleTime: 60_000,
});

export async function saveProfile(input: BusinessProfileInput) {
  const res = await api.api.business.profile.$post({ json: input });
  if (!res.ok) throw await mapResponseError(res);
  return res.json();
}
